import { markRaw } from 'vue'
import { toast } from 'vue-sonner'

import ToastCard from '@/shared/components/toast/ToastCard.vue'

import type { ToastCardProps, ToastSeverity } from '@/shared/components/toast/ToastCard.vue'

export type AppToastOptions = Omit<ToastCardProps, 'severity' | 'summary'> & {
  duration?: number
}

const DEFAULT_DURATION_MS = 3000

// markRaw once at module level — the card is a static component, not reactive state
const card = markRaw(ToastCard)

const show = (severity: ToastSeverity, summary: string, options: AppToastOptions = {}) => {
  const { duration, ...content } = options
  toast(card, {
    componentProps: { severity, summary, ...content } satisfies ToastCardProps,
    // Errors stay until dismissed, matching the previous PrimeVue behavior
    duration: duration ?? (severity === 'error' ? Infinity : DEFAULT_DURATION_MS)
  })
}

export const appToast = {
  success: (summary: string, options?: AppToastOptions) => show('success', summary, options),
  info: (summary: string, options?: AppToastOptions) => show('info', summary, options),
  warning: (summary: string, options?: AppToastOptions) => show('warning', summary, options),
  error: (summary: string, options?: AppToastOptions) => show('error', summary, options)
}
